var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 22,
  viewBox: "0 0 24 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0.5L8.58752 7.415L0.960022 8.5175L6.48002 13.9025L5.17502 21.5L12 17.915L18.825 21.5L17.52 13.9025L23.04 8.525L15.4125 7.415L12 0.5Z",
  fill: "#F2C94C"
})));
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDAuNUw4LjU4NzUyIDcuNDE1TDAuOTYwMDIyIDguNTE3NUw2LjQ4MDAyIDEzLjkwMjVMNS4xNzUwMiAyMS41TDEyIDE3LjkxNUwxOC44MjUgMjEuNUwxNy41MiAxMy45MDI1TDIzLjA0IDguNTI1TDE1LjQxMjUgNy40MTVMMTIgMC41WiIgZmlsbD0iI0YyQzk0QyIvPgo8L3N2Zz4K";